<script setup lang="ts">
defineProps<{
  isIndex?: boolean
}>()
</script>

<template>
  <div
    class="auth-main absolute text-center p-8 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
  >
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.auth-main {
  background-color: #ffffff;
  box-shadow: -4px 0px 20px #413d581a;
  border-radius: 16px;
  width: 360px;
  transition: all 0.3s ease-in-out;

  .title {
    max-width: 170px;
    font-size: 16px;
    line-height: 20px;
    font-weight: 500;
  }

  .desc {
    font-size: 14px;
    letter-spacing: -0.28px;
    color: var(--gray-700);

    .link {
      color: var(--coral-900);
      font-weight: 500;
    }
  }

  .text-bottom {
    letter-spacing: -0.28px;
    font-size: 14px;
    font-weight: 500;
  }
}

@media screen and (max-width: 380px) {
  .auth-main {
    width: 300px;
    padding: 20px !important;
  }
}
</style>
